module.exports = __webpack_public_path__ + "img/patrick-pro.6f4dcdd6.jpg";